export enum ApplicationRoles {
    Default = 'Viguideplanning.Default',
    Admin = 'Viguideplanning.Admin',
    NevisDefault = 'NEVIS-Viguideplanning.Default'
}
